import { useState } from 'react';
import Reveal from '@/components/base/Reveal';
import { faqItems } from '@/mocks/homeData';

export default function GuideFaq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="guide" className="w-full scroll-mt-24 bg-background-50">
      <div className="mx-auto grid w-full max-w-[1200px] grid-cols-1 gap-10 px-4 py-12 md:px-6 md:py-16 lg:grid-cols-3 lg:gap-14">
        <Reveal>
          <div className="lg:sticky lg:top-32">
            <span className="text-xs font-label tracking-[0.2em] text-primary-600">GETTING STARTED</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">新手指引与常见问题</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              第一次来不知道从哪下手？这几条最常被问到的问题，看完基本就能顺利进场。
            </p>
            <a
              href="#address"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-login-circle-line" />
              返回入口列表
            </a>
          </div>
        </Reveal>

        <Reveal delay={100} className="lg:col-span-2">
          <div className="flex flex-col gap-3">
            {faqItems.map((item, index) => {
              const isOpen = open === index;
              return (
                <div
                  key={item.q}
                  className={`overflow-hidden rounded-lg border bg-background-50 transition-colors ${
                    isOpen ? 'border-primary-200' : 'border-background-200'
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? null : index)}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 px-4 py-4 text-left md:px-5"
                  >
                    <span className="flex items-center gap-3">
                      <span className="font-heading text-sm text-foreground-400">
                        {String(index + 1).padStart(2, '0')}
                      </span>
                      <span className="font-heading text-base font-bold text-foreground-950">{item.q}</span>
                    </span>
                    <i className={`shrink-0 text-lg text-foreground-500 ${isOpen ? 'ri-subtract-line' : 'ri-add-line'}`} />
                  </button>
                  {isOpen && (
                    <div className="border-t border-background-200 bg-background-100 px-4 py-4 md:px-5">
                      <p className="pl-0 text-sm leading-relaxed text-foreground-600 md:pl-9">{item.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </Reveal>
      </div>
    </section>
  );
}